import axios from 'axios';
import axiosInstance from '../../../services/axios/axios';
import {
	getWorkItem,
	postWIQL,
} from '../../../services/axios/AzureDevOps/_api';
import { POST_WIQL } from '../../../services/axios/AzureDevOps/_payloads';
import { then } from '../../../services/axios/_utility';

export const getUserWorkItemsByEmail = (email, dispatch = null) => {
	let body = { ...POST_WIQL };
	const paramIdentifier = `${email.replace(/.TST/gi, '.edu')}`;

	body.query =
		body.query +
		` AND (([System.State] <> 'Closed'` +
		` OR [System.IterationPath] = @currentIteration('[Identity Management System]\\Identity Management System Team <id:df7c78f9-34d5-4a7b-a7f6-0c01bd1fe368>')` +
		` OR [System.IterationPath] = @currentIteration('[Identity Management System]\\Identity Management System Team <id:df7c78f9-34d5-4a7b-a7f6-0c01bd1fe368>') - 1)` +
		` AND [System.State] <> 'Removed'` +
		` AND [Custom.OriginalRequestor] CONTAINS WORDS '${paramIdentifier}')` +
		' ORDER BY [System.ChangedDate] DESC';
	return postWIQL(body).then(response =>
		then(response, payload => payload, dispatch)
	);
};

/**
 * Retrieves details of work item(s) of interest.
 *
 * @param {object[]} arrID array of work items
 * @returns {Promise<object[]>} array of work items with details.
 */
export const getWorkItems = async arrID => {
	let results = [];
	const arrResponses = await axios.all(
		arrID.map(item => getWorkItem(item.Id))
	);
	if (arrResponses?.length > 0) {
		let arrWorkItems = arrResponses.map(response => response.data?.payload);
		results = arrWorkItems;
	}
	return results;
};

export const getSecondaryEmails = async (upn, dispatch) => {
	return axiosInstance
		.get('api/ActiveDirectory/SecondaryEmail', {
			params: {
				upn: upn,
			},
		})
		.then(response => then(response, payload => payload, dispatch));
};
